module.exports = __webpack_public_path__ + "static/media/screenshot7.cf60de75.png";